export const replaceNewlinesWithBreaks = (text) => {
  return text?.replace(/\n+(\s*\n+)?/g, '<br/>')
}